<template>
  <header
    class="sticky top-0 h-18 bg-white dark:bg-gray-800 shadow-md transition-colors duration-200"
  >
    <nav class="flex items-center p-4">
      <div class="flex justify-start flex-auto">
        <router-link :to="{ name: isAuth ? 'overview' : 'landing' }">
          <img src="/img/brand.svg" class="w-36" />
        </router-link>
      </div>

      <div class="flex justify-end flex-1">
        <dark-mode-toggle />

        <template v-if="isAuth">
          <router-link
            :to="{ name: 'overview' }"
            class="flex items-center mx-2 cursor-pointer text-gray-700 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white"
          >
            <Icon class="h-5 mx-1" :path="mdiViewDashboard" />
            <div class="hidden lg:block">Models</div>
          </router-link>
          <router-link
            :to="{ name: 'api-keys' }"
            class="flex items-center mx-2 cursor-pointer text-gray-700 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white"
          >
            <Icon class="h-5 mx-1" :path="mdiKey" />
            <div class="hidden lg:block">API keys</div>
          </router-link>
          <router-link
            :to="{ name: 'profile' }"
            class="flex items-center mx-2 cursor-pointer text-gray-700 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white"
          >
            <Icon class="h-5 mx-1" :path="mdiAccount" />
            <div class="hidden lg:block">Profile</div>
          </router-link>
          <div
            class="flex items-center mx-2 cursor-pointer text-gray-700 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white"
            @click="logOut()"
          >
            <Icon class="h-5 mx-1" :path="mdiLogoutVariant" />
            <div class="hidden lg:block">Log out</div>
          </div>
        </template>

        <div
          v-else
          class="flex items-center mx-2 cursor-pointer text-gray-700 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white"
          @click="$router.push({ name: 'login' })"
        >
          <Icon class="h-5 mx-1" :path="mdiLoginVariant" />
          <div class="hidden lg:block">Log in</div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import {
  mdiLogoutVariant,
  mdiLoginVariant,
  mdiViewDashboard,
  mdiKey,
  mdiAccount,
} from "@mdi/js";
import { firebaseAuth } from "@/services/firebase";
import { signOut } from "firebase/auth";
import DarkModeToggle from "@/components/DarkModeToggle.vue";

export default {
  components: {
    DarkModeToggle,
  },
  props: { isAuth: Boolean },
  data() {
    return {
      mdiLogoutVariant,
      mdiLoginVariant,
      mdiViewDashboard,
      mdiKey,
      mdiAccount,
    };
  },
  methods: {
    async logOut() {
      try {
        await signOut(firebaseAuth);
        this.$router.replace({ name: "login" });
        this.$store.commit("setUser", null);
      } catch (error) {
        alert(error.message);
      }
    },
  },
};
</script>

<style scoped></style>
